import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34385525&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34385525",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34385525')) {
      api.createRecord('34385525', component.options)
    } else {
      api.reload('34385525', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=34385525&scoped=true", function () {
      api.rerender('34385525', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/roleManage/index.vue"
export default component.exports